//@author: devin

import { NgModule } from "@angular/core";
import { S25SecurityLinkComponent } from "./s25.security.link.component";
import { S25PipesModule } from "../../pipes/s25.pipes.module";

import { S25IconComponent } from "../s25-icon/s25.icon.component";

@NgModule({
    declarations: [S25SecurityLinkComponent],
    imports: [S25PipesModule, S25IconComponent],
    providers: [S25SecurityLinkComponent],
    exports: [S25SecurityLinkComponent],
})
export class S25SecurityLinkModule {}
